
import { Outlet,useLocation } from "react-router-dom";
import HeaderComponent from "../header";
import AppTabsComponent from "../shared/appTabsComponent";

const Cases = () => {
  const location = useLocation();
    const breadcrumbMapping = {
        'cases': 'Cases',
        'templates': 'Templates'
    };
    const currentTab = location?.pathname?.split('/')?.pop();
    const tabName = breadcrumbMapping[currentTab] || "Cases";
    const breadCrumbList = [
     { bname: tabName }
    ]
  return (
    <div className=''>
      <HeaderComponent breadCrumbList={breadCrumbList} />
     
       <AppTabsComponent serviceName={"CardsManageService.Cases"} tabPosition='top' isNoRouting={false} />
                 <Outlet />
    </div>
  );
};
export default Cases;
